// src/Components/CookiePolicy.jsx
import React, { useEffect } from "react";
import { Box, Typography, Link } from "@mui/material";
import CookieRoundedIcon from "@mui/icons-material/CookieRounded";
import Footer from "./Footer";



// אם הפונט לא נטען גלובלית:
//import "@fontsource/assistant/400.css";
// import "@fontsource/assistant/700.css";

export default function CookiePolicy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

	 return (
	  <Box dir="rtl" sx={{ backgroundColor: "#f6f9fc", minHeight: "100vh", fontFamily: "Assistant, sans-serif" }}>
		  <Box
			sx={{
			  fontSize: 16,
			  lineHeight: 1.85,
              width: "min(980px, 92%)",
              mx: "auto",
              py: { xs: 3, md: 5 },
			  "& *": { fontFamily: "Assistant, sans-serif" },
			}}
		  >

        <Box
          sx={{
            mb: 2.5,
            p: { xs: 2.25, md: 3 },
            borderRadius: "22px",
            background: "linear-gradient(135deg, #eef6ff 0%, #ffffff 65%, #fff8ec 100%)",
            border: "1px solid #dceafb",
            display: "flex",
            alignItems: "center",
            gap: 1.75,
          }}
        >
          <Box sx={{ width: 52, height: 52, borderRadius: "16px", bgcolor: "#fff0d7", color: "#e58a00", display: "grid", placeItems: "center", flexShrink: 0 }}>
            <CookieRoundedIcon sx={{ fontSize: 30 }} />
          </Box>
          <Box>
            <Typography component="h1" sx={{ fontWeight: 800, fontSize: { xs: 24, md: 30 }, color: "#17324d", lineHeight: 1.2 }}>
              מדיניות עוגיות
            </Typography>
            <Typography sx={{ color: "#61758a", mt: 0.5, fontSize: { xs: 14, md: 15 } }}>
              מידע על העוגיות והטכנולוגיות המשמשות להפעלה תקינה של Bidit
            </Typography>
          </Box>
        </Box>

        <Box sx={{ bgcolor: "#fff", border: "1px solid #e5edf5", borderRadius: "22px", boxShadow: "0 12px 34px rgba(22, 50, 77, 0.07)", p: { xs: 2.25, sm: 3, md: 4 }, overflowWrap: "anywhere", "& h2, & h3, & h4, & h5, & h6": { color: "#17324d", fontWeight: 800 }, "& p, & li": { color: "#34495e" } }}>

        <Typography paragraph>
          אתר <b>Bidit</b> ("האתר", "האפליקציה", "אנחנו") עושה שימוש בעוגיות (Cookies) ובטכנולוגיות דומות לצורך תפעול תקין, אבטחה ושיפור חוויית המשתמש.
          מדיניות זו נועדה להסביר מהן עוגיות, כיצד אנו משתמשים בהן, ואילו אפשרויות קיימות למשתמשים בנוגע לניהולן.
        </Typography>

        {/* כותרת ביניים גדולה מעט */}
        <Typography variant="h5" sx={{ mt: 3, mb: 1, fontSize: 22 }}>
          מהן עוגיות (Cookies)
        </Typography>
        <Typography paragraph>
          עוגיות הן קבצי טקסט קטנים הנשמרים בדפדפן או במכשיר שלך בעת ביקור באתר אינטרנט.
          הן מאפשרות לאתר לפעול כראוי, לשמור הגדרות בסיסיות, לאבטח את הסשן שלך, ולשפר את חוויית השימוש הכוללת.
        </Typography>

        <Typography variant="h5" sx={{ mt: 3, mb: 1, fontSize: 22 }}>
          סוגי העוגיות שבהן נעשה שימוש
        </Typography>

        {/* כותרת משנה מעט גדולה */}
        <Typography variant="h6" sx={{ mt: 2, mb: 1, fontSize: 22 }}>
          א. עוגיות חיוניות (Essential Cookies)
        </Typography>
        <Typography paragraph>
          אלו עוגיות הנדרשות להפעלה תקינה ובטוחה של האתר, כגון זיהוי משתמש פעיל או סשן זמני (session ID, token),
          שמירת שפה או העדפות תצוגה, הגנה מפני שימוש לרעה (CSRF, אבטחה), ותפעול תקין של תהליכי תשלום (Stripe).
          עוגיות אלו נטענות אוטומטית עם הכניסה לאתר ואינן דורשות הסכמה נפרדת.
        </Typography>

        <Typography variant="h6" sx={{ mt: 2, mb: 1, fontSize: 22 }}>
          ב. עוגיות צד שלישי (Third-Party Cookies)
        </Typography>
        <Typography paragraph>
          באתר ייתכן שימוש בעוגיות של ספקים חיצוניים, כגון Google לרכיבים טכניים, Stripe לצורך אבטחת תשלום ו-Meta לצורכי מדידת ביצועי פרסום והרשמות.
          השימוש בעוגיות אלו כפוף למדיניות הפרטיות של אותם ספקים. כלי המדידה והפרסום של Meta מופעלים רק לאחר קבלת הסכמה מתאימה מהמשתמש.
        </Typography>

        <Typography variant="h5" sx={{ mt: 3, mb: 1, fontSize: 24 }}>
          מתי אנו שומרים עוגיות ומידע אישי
        </Typography>
        <Typography paragraph>
          עם הכניסה לאתר נוצרות עוגיות חיוניות הדרושות להפעלתו התקינה ולאבטחת השימוש בו. כלי מדידה ופרסום שאינם חיוניים, לרבות Meta Pixel, מופעלים רק לאחר הסכמת המשתמש.
          העוגיות החיוניות עשויות לכלול מזהה סשן זמני, העדפות שפה או מנגנוני אבטחה (כגון CSRF).
        </Typography>
        <Typography paragraph>
          מידע אישי עשוי להישמר רק לאחר שהמשתמש בוחר להירשם לשירות, להיכנס לחשבונו, או להזין פרטים באופן יזום לצורך קבלת שירות.
          במקרים אלו נשמר המידע לצורך תפעול החשבון, אימות זהות המשתמש, מתן שירות, בקרה פנימית,
          וכן לצורכי ניתוח סטטיסטי ושיווק מותר לפי דין - כגון שליחת עדכונים, הצעות רלוונטיות או התאמת תוכן למשתמש.
          השימוש במידע זה נעשה בהתאם למדיניות הפרטיות של האתר ובכפוף להסכמה שניתנה בעת ההרשמה.
        </Typography>

        <Typography variant="h5" sx={{ mt: 3, mb: 1, fontSize: 24 }}>
          כיצד ניתן לנהל או למחוק עוגיות
        </Typography>
        <Typography paragraph>
          ניתן לחסום או למחוק עוגיות בהגדרות הדפדפן. חסימת עוגיות חיוניות עלולה לפגוע בפעילות האתר. להנחיות מפורטות:
        </Typography>
        <ul style={{ marginTop: 0 }}>
          <li>
            <Link href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer">
              Google Chrome
            </Link>
          </li>
          <li>
            <Link href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac" target="_blank" rel="noreferrer">
              Safari
            </Link>
          </li>
          <li>
            <Link href="https://support.microsoft.com/en-us/help/4027947" target="_blank" rel="noreferrer">
              Edge
            </Link>
          </li>
          <li>
            <Link href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="noreferrer">
              Firefox
            </Link>
          </li>
        </ul>

        <Typography variant="h5" sx={{ mt: 3, mb: 1, fontSize: 24 }}>
          עדכונים ויצירת קשר
        </Typography>
        <Typography paragraph>
          מעת לעת נעדכן את מדיניות העוגיות בהתאם לשינויים בחוק, בטכנולוגיה או בשירותים.
          לשאלות ובקשות:{" "}
          <Link href="mailto:bidit.customer.service@gmail.com">bidit.customer.service@gmail.com</Link>
        </Typography>
        </Box>
      </Box>

      <Footer />
    </Box>
  );
}
